import request from '../../utils/request';

export const saveAppSettingsService = data => {
  return async dispatch => {
    
    const response = await dispatch(
      request('/app-settings', {
        method: 'POST',
        data,
      }),
    );
    return response;
  };
};

export const getAppSettingsService = (params = null) => {
  if (params === null) {
    return async dispatch => {
      const response = await dispatch(
        request('/app-settings', {
          method: 'GET',
        }),
      );
      return response;
    };
  }
  return async dispatch => {
    const response = await dispatch(
      request('/app-settings', {
        method: 'GET',
        params,
      }),
    );
    return response;
  };
};

export const getAppSettingsCompleteByIdService = id => {
  return async dispatch => {
    const response = await dispatch(
      request('/app-settings/' + id + '/complete', {
        method: 'GET',
      }),
    );
    return response;
  };
};

export const getSimpleAppSettingsListService = (idList = '', all = false) => {
  return async dispatch => {
    const response = await dispatch(
      request('/app-settings/exportPdf', {
        method: 'GET',
        params: {
          id: idList,
          all,
        },
      }),
    );
    return response;
  };
};
